import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useLayoutEffect } from 'react';

function call(ref, value) {
  if (typeof ref === 'function') ref(value);else if (ref != null) ref.current = value;
}

function useEffectfulState(fn) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var cb = arguments.length > 2 ? arguments[2] : undefined;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      set = _useState2[1];

  useLayoutEffect(function () {
    var value = fn();
    set(value);
    call(cb, value);
    return function () {
      return call(cb, null);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return state;
}

export default useEffectfulState;